@if (tableConfig()) {
  <ui-dataset-table
    [data]="unsavedVehicles()"
    [config]="tableConfig()!"
    [initialSelectedIds]="forcedSelectedIds()"
    (rowAction)="onRowAction($event)"
    (selectionChange)="onSelectionChange($event)"
  ></ui-dataset-table>
}

<!-- CELL TEMPLATES -->
<ng-template #imageCell let-row>
  <ui-vehicle-icon [vehicle]="row"></ui-vehicle-icon>
</ng-template>
